import { render, staticRenderFns } from "./AppBlockTitle.vue?vue&type=template&id=d1422c46&scoped=true"
import script from "./AppBlockTitle.vue?vue&type=script&lang=js"
export * from "./AppBlockTitle.vue?vue&type=script&lang=js"
import style0 from "./AppBlockTitle.vue?vue&type=style&index=0&id=d1422c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1422c46",
  null
  
)

export default component.exports